<template>
  <div class="medical-detail-cntainer">
    <TopBg
      title="合理诊疗智慧监管系统"
      sub-title="聚焦医疗行为的智能监测、风险预警及违规拦截。"
      :bg="topBg"
    />
    <div class="main-content page">
      <!-- 产品简介 -->
      <div class="section">
        <div class="title">产品简介</div>
        <div class="rows-2">
          <info-item-vue
            title="产品背景"
            desc="本系统的建设源于江苏省卫生健康委员会的明确政策要求。根据江苏省卫健委于2025年发布的《关于推进合理诊疗智慧监管工作的通知》（苏卫规划[2025]44号），江苏省计划构建“全覆盖、全链条、智慧化”的医疗监管体系。"
          >
            <template #icon>
              <img src="../../../assets/bj.svg" alt="" />
            </template>
          </info-item-vue>
          <info-item-vue
            title="产品概述"
            desc="“合理诊疗智慧监管系统”是一个旨在对诊疗行为进行全流程、智能化监管的信息化平台。其核心目标是实现 “医疗机构、医务人员、医疗行为”全覆盖，以及 “事前、事中、事后”全链条的智慧化监管。"
          >
            <template #icon>
              <img src="../../../assets/gs.svg" alt="" />
            </template>
          </info-item-vue>
        </div>
      </div>
      <!-- 解决方案 -->
      <div class="section">
        <div class="title">解决方案</div>
        <div class="rows-3">
          <solution-item
            title="建设内容"
            desc="主要包含首页概览、监管指标管理、指标拦截预警、预警记录管理、监管数据预生成和数据综合统计分析等。"
          >
            <template #icon>
              <img src="./assets/solution01.svg" alt="" />
            </template>
          </solution-item>
          <solution-item
            title="实施周期"
            desc="在医院与厂商高度配合下，一阶段实施周期约为2~3周，以确保能按时完成数据上报要求。"
          >
            <template #icon>
              <img src="./assets/solution02.svg" alt="" />
            </template>
          </solution-item>
          <solution-item
            title="整体优势"
            desc="江苏省内率先完成独立系统的建设，已预置省卫健委首批监管指标规则；团队具备医保智能审核领域的深厚经验，熟悉政策与业务流程。"
          >
            <template #icon>
              <img src="./assets/solution03.svg" alt="" />
            </template>
          </solution-item>
        </div>
      </div>

      <!-- 产品价值 -->
      <div class="section">
        <div class="title">产品价值</div>
        <div class="rows-3">
          <value-item-vue
            title="满足监管合规，规避政策风险"
            desc="系统建设是落实省级政策的必要举措，能确保医院按时完成与省级平台的对接，避免因未按期完成而面临的通报、约谈等监管风险。"
          >
            <template #icon>
              <img src="./assets/value01.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue
            title="规范诊疗行为，规避法律风险"
            desc="通过系统实时拦截和预警违规操作（如不合理治疗、不合理收费），可以有效避免因诊疗行为不规范导致的行政处罚或医疗法律纠纷，保护医院和医务人员的合法权益。"
          >
            <template #icon>
              <img src="./assets/value02.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue
            title="提升医疗质量与治理水平"
            desc="系统通过对诊疗全过程的监控与数据分析，有助于医院内部发现管理薄弱环节，促进临床行为的规范化，最终提升合理诊疗水平和医德医风治理能力，实现精细化管理。"
          >
            <template #icon>
              <img src="./assets/value03.svg" alt="" />
            </template>
          </value-item-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBg from "../../common/TopBg.vue";
import infoItemVue from "../../common/info-item.vue";
import valueItemVue from "../../common/value-item.vue";
import SolutionItem from "../../common/solution-item.vue";

export default {
  name: "DrgPlatform",
  components: {
    TopBg,
    infoItemVue,
    valueItemVue,
    SolutionItem,
  },
  data() {
    return {
      topBg: require("./assets/bg.png"),
    };
  },
};
</script>
